export interface PolicyConfigurationSubcategory {
  key: string;
  code: string;
  label: string;
  apiName?: string;
}

export interface PolicyConfigurationBuildingBlock {
  key: string;
  code: string;
  label: string;
  subcategories: PolicyConfigurationSubcategory[];
}

export const POLICY_CONFIGURATION_BUILDING_BLOCKS: PolicyConfigurationBuildingBlock[] = [
  {
    key: 'employmentTerms',
    code: '0',
    label: 'Employment Terms',
    subcategories: [
      {
        key: 'holidaysAndCredits',
        code: '0.1',
        label: 'Holidays and Holiday Credit Rules',
      },
    ],
  },
  {
    key: 'payRule',
    code: '1',
    label: 'Pay Rule',
    subcategories: [
      {
        key: 'fixedRule',
        code: '1.1',
        label: 'Fixed Rule',
      },
      {
        key: 'signOffRestriction',
        code: '1.2',
        label: 'Sign off Restriction',
      },
      {
        key: 'approvalRestriction',
        code: '1.3',
        label: 'Approval Restriction',
      },
      {
        key: 'processingOrder',
        code: '1.4',
        label: 'Processing Order',
        apiName: 'Sequence Rule',
      },
    ],
  },
  {
    key: 'workRule',
    code: '2',
    label: 'Work Rule & Building Blocks',
    subcategories: [
      {
        key: 'rounding',
        code: '2.1',
        label: 'Rounding Rule',
      },
      {
        key: 'exceptionRule',
        code: '2.2',
        label: 'Exception Rule',
      },
      {
        key: 'breakRule',
        code: '2.3',
        label: 'Break Rule',
      },
      {
        key: 'bonusDeductionRule',
        code: '2.4',
        label: 'Bonus/Deductions Rule',
      },
      {
        key: 'overtimeRule',
        code: '2.5',
        label: 'Overtime Rule',
      },
    ],
  },
];

export const POLICY_CONFIGURATION_BUILDING_BLOCK_MAP = POLICY_CONFIGURATION_BUILDING_BLOCKS.reduce<Record<string, PolicyConfigurationBuildingBlock>>(
  (acc, block) => {
    acc[block.key] = block;
    return acc;
  },
  {},
);

export const getPolicyConfigurationSubcategories = (
  blockKey: string,
): PolicyConfigurationSubcategory[] => POLICY_CONFIGURATION_BUILDING_BLOCK_MAP[blockKey]?.subcategories ?? [];
